<template>
  <div>
    <div class="table-section refresh">
      <el-button  @click="getList()">刷新</el-button>
    </div>
    <div class="table-section">
      <el-table :data="tableData" :header-row-style="headerRowStyle" max-height="550px" class="table-section" border
        highlight-current-row :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }" style="width: 100%">
        <el-table-column prop="reptName" label="报表名称" />
        <el-table-column prop="taskStat" label="状态">
          <template slot-scope="scope">
            {{ getStatus(scope.row.taskStat) }}
          </template>
        </el-table-column>
        <el-table-column prop="creeTime" label="创建时间" width="180" />
        <el-table-column prop="creeUser" label="创建人" />
        <el-table-column prop="enddTime" label="完成时间" width="180" />
        <el-table-column label="操作">

          <template slot-scope="scope">
            <el-button v-if="scope.row.taskStat == 3" type="primary" 
              @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-section">
      <el-pagination :page-size="params.size" :total="total" :page-sizes="[5, 10, 15, 20]"
        layout="total, sizes, prev, pager, next" @current-change="changePage" @size-change="changeSize" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryReportTaskList } from '@/api/global'
import { getDictionaryList } from '@/api/manage'
export default {
  name: 'download',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      tableData: [],
      params: {
        page: 1,
        size: 10,
        userId: ''
      },
      total: 0,
      statusList: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  async created() {
    const statusListRes = await getDictionaryList('report_task_status')
    statusListRes.data.map((item) => {
      this.statusList.push({
        label: item.dictLabel,
        value: Number(item.dictValue)
      })
    })
    this.getList()
  },
  methods: {
    download(data) {
      let link = document.createElement('a')
      link.href = data.dowdUrll
      link.download = data.reptName + '.xlsx'
      link.click()
    },
    async getList() {
      this.params.userId = this.currentUser.id
      const queryReportTaskListRes = await queryReportTaskList(this.params)
      this.tableData = queryReportTaskListRes.data.records
      this.total = queryReportTaskListRes.data.total
    },
    /**
     * 切换页数
     */
    changePage(currentPage) {
      this.params.page = currentPage
      this.getList()
    },
    /**
     * 切换size
     */
    changeSize(currentSize) {
      this.params.size = currentSize
      this.params.page = 1
      this.getList()
    },
    getStatus(status) {
      const list = this.statusList.filter((item) => item.value === status)
      if (list.length > 0) {
        return list[0].label
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cell {
  text-align: center !important;
}

.el-table {
  thead {

    tr,
    th {
      background-color: #eee;
    }
  }

  tr,
  th {
    text-align: center !important;
  }
}

.table-section {
  margin-top: 20px;
}

.pagination-section {
  margin-top: 20px;
  text-align: center;
}

.refresh {
  float: right;
  margin-bottom: 20px;
}
</style>
